
import DissBreadcrumbs from './pages/DissBreadcrumbs'
import DetailAuthor  from './pages/DetailAuthor'
import AdminPage from "./pages/adminPage/AdminPage"
import ListDissSovet from './pages/list/ListDissSovet'
import ListArchivedApplications from "./pages/list/ListArchivedApplications"
import ListProgressApplications from "./pages/list/ListProgressApplications"
import CurrentDissSovet from "./pages/CurrentDissSovet"
import CreateApplication from "./pages/CreateApplication"
import ListLanguage from "./pages/adminPage/page/ListLanguage"
import ListScientific_specialty from  "./pages/adminPage/page/ListScientific_specialty"
import ListAcademic_degree from  "./pages/adminPage/page/ListAcademic_degree"
import ListAcademic_rank from "./pages/adminPage/page/ListAcademic_rank"
import ListOrganization from "./pages/adminPage/page/ListOrganization"
import ListScientific_industry from "./pages/adminPage/page/ListScientific_industry"
import ListScientific_field from "./pages/adminPage/page/ListScientific_field"
import ListPerson from "./pages/adminPage/page/ListPerson"
import ListPerson_academic_degree from "./pages/adminPage/page/ListPerson_academic_degree"
import ListDissertation_council from "./pages/adminPage/page/ListDissertation_council"
import Dissertation_council_scientific_field from "./pages/adminPage/page/ListDissertation_council_scientific_field"
import ListDissertation_council_member from "./pages/adminPage/page/ListDissertation_council_member"
import ListCandidate_case from "./pages/adminPage/page/ListCandidate_case"
import ProgressApplication from "./pages/ProgressApplication"
import ListReview_opponent from "./pages/adminPage/page/ListReview_opponent"
import ListReview_person from "./pages/adminPage/page/ListReview_person"
import ListReview_organization from "./pages/adminPage/page/ListReview_organization"
import TemplatesDocs from "./pages/TemplatesDocs"
import ListDocTemplate  from "./pages/adminPage/page/ListDocTemplate"
import ListScientific_boss from "./pages/adminPage/page/ListScientific_boss"
import ListScientific_consultant from "./pages/adminPage/page/ListScientific_consultant"
import ListStatus_history from "./pages/adminPage/page/ListStatus_history"
import ListRole from "./pages/adminPage/page/ListRole"
import QRPage from "./pages/QRPage"
import ListTokenRole from "./pages/adminPage/page/ListTokenRole"
import PrintQr from "./pages/adminPage/page/PrintQr"

const organization = String(process.env.VUE_APP_ORGANIZATION_PREFIX).replace('/', '');
const account = String(process.env.VUE_APP_ACCOUNTS_PREFIX).replace('/', '');

export default ([

  {
    path: '/:token([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})?/diss',
    name: 'OpenDiss',

    component: DissBreadcrumbs,
    meta: {
      breadcrumb: 'Диссертации',
      instances: [
        process.env.VUE_APP_DISS_PREFIX,
      ],
    },
    children:[
      {
        path: 'author/:uid([0-9a-z-]+)/',
        name: 'DetailAuthor',
        component: DetailAuthor,
        meta: {
          breadcrumb: 'Автор',
          instances: [
            process.env.VUE_APP_DISS_PREFIX,
          ]
        },
      },
      {
        path: 'author/qr/:uid([0-9a-z-]+)/',
        name: 'QRPage',
        component: QRPage,
        meta: {
          breadcrumb: 'QR сведения',
          instances: [
            process.env.VUE_APP_DISS_PREFIX,
          ]
        },
      },
      {
        path: 'admin',
        name: 'AdminPage',
        component: AdminPage,
        meta: {
          requiredAuth: true,
          breadcrumb: 'Админ',
          instances: [
            process.env.VUE_APP_DISS_PREFIX,
            organization,
            account
          ]
        },
        children:[
          {
            path: 'list/history/',
            name: 'ListStatus_history',
            component: ListStatus_history,
            meta: {
              requiredAuth: true,
              breadcrumb: 'История статусов',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'list/role/',
            name: 'ListRole',
            component: ListRole,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Роли',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
                organization,
                account
              ]
            },
          },
          {
            path: 'list/role/token/',
            name: 'ListTokenRole',
            component: ListTokenRole,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Внешние роли',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
                organization,
                account
              ]
            },
          },
          {
            path: 'list/review/consultant/',
            name: 'ListScientific_consultant',
            component: ListScientific_consultant,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Отзывы',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'list/review/scientific/',
            name: 'ListScientific_boss',
            component: ListScientific_boss,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Отзывы',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'list/review/opponent',
            name: 'ListReview_opponent',
            component: ListReview_opponent,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Отзывы',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'list/review/person',
            name: 'ListReview_person',
            component: ListReview_person,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Отзывы',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'list/review/organization',
            name: 'ListReview_organization',
            component: ListReview_organization,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Отзывы',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'candidate/case/',
            name: 'ListCandidate_case',
            component: ListCandidate_case,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Аттестационное дело соискателя',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
            children:[
              {
                path: 'print/qr/:uid([0-9a-z-]+)/',
                name: 'QRPrint',
                component: PrintQr,
                meta: {
                  breadcrumb: 'QR',
                  instances: [
                    process.env.VUE_APP_DISS_PREFIX,
                  ]
                },
              },
            ]
          },

          {
            path: 'council/member/',
            name: 'ListDissertation_council_member',
            component: ListDissertation_council_member,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Член диссертационного совета',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'council/scientific/field/',
            name: 'ListDissertation_council_scientific_field',
            component: Dissertation_council_scientific_field,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Научные специальности и отрасли науки',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'dissertation/council/',
            name: 'ListDissertation_council',
            component: ListDissertation_council,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Диссертационный совет',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'person/academic/degree/',
            name: 'ListPerson_academic_degree',
            component: ListPerson_academic_degree,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Учёные степени лица (по научным специальности)',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'template/',
            name: 'ListDocTemplate',
            component: ListDocTemplate,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Шаблоны',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'person/',
            name: 'ListPerson',
            component: ListPerson,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Персоны',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'scientific/field/',
            name: 'ListScientific_field',
            component: ListScientific_field,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Научная специальность',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'scientific/industry/',
            name: 'ListScientific_industry',
            component: ListScientific_industry,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Отрасль науки',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'organization/',
            name: 'ListOrganization',
            component: ListOrganization,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Список организаций',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'scientific/academic/degree/',
            name: 'ListAcademic_degree',
            component: ListAcademic_degree,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Список учёных степеней',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'scientific/specialty/',
            name: 'ListScientific_specialty',
            component: ListScientific_specialty,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Научные специальности',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'language/',
            name: 'ListLanguage',
            component: ListLanguage,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Языки',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: 'academic/rank/',
            name: 'ListAcademic_rank',
            component: ListAcademic_rank,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Учёное звание',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
        ]
      },
      {
        path: 'docs',
        name: 'TemplatesDocs',
        component: TemplatesDocs,
        meta: {
          requiredAuth: true,
          breadcrumb: 'Шаблоны документов',
          instances: [
            process.env.VUE_APP_DISS_PREFIX,
          ]
        },
      },
      {
        path: 'list',
        name: 'ListDissSovet',
        component: ListDissSovet,
        meta: {
          requiredAuth: true,
          breadcrumb: 'Диссертационные советы',
          instances: [
            process.env.VUE_APP_DISS_PREFIX,
          ]
        },
        children:[
          {
            path: ':id([0-9]+)/',
            name: 'CurrentDissSovet',
            component: CurrentDissSovet,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Диссертационный совет',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
        ]
      },
      {
        path: 'archived',
        name: 'ListArchivedApplications',
        component: ListArchivedApplications,
        meta: {
          requiredAuth: true,
          breadcrumb: 'Архивные заявки',
          instances: [
            process.env.VUE_APP_DISS_PREFIX,
          ]
        },
        children:[
          {
            path: ':id([0-9]+)/',
            name: 'ArchivedApplication',
            component: ProgressApplication,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Архивное заявление',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
        ]

      },
      {
        path: 'progress',
        name: 'ListProgressApplications',
        component: ListProgressApplications,
        meta: {
          requiredAuth: true,
          breadcrumb: 'Заявки в работе',
          instances: [
            process.env.VUE_APP_DISS_PREFIX,
          ]
        },
        children:[
          {
            path: ':id([0-9]+)/',
            name: 'ProgressApplication',
            component: ProgressApplication,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Заявление',
              instances: [
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
        ]
      },
      {
        path: 'create',
        name: 'CreateApplication',
        component: CreateApplication,
        meta: {
          requiredAuth: true,
          breadcrumb: 'Создать анкету',
          instances: [
            process.env.VUE_APP_DISS_PREFIX,
          ]
        },
      },
    ]
  },

])


